module.exports = __webpack_public_path__ + "static/media/sound.33e69cd6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/images/sound.mp3
// module id = 646
// module chunks = 0